<template>
  <section id="processMap" class="process-wrap center">
    <div class="section-wrapper d-flex flex-column">
      <div class="title-wrap">
        <p
          class="header-2 bold color-white"
          v-bind:class="{ 'mg-50': isMobile }"
        >
          Process Map
        </p>
        <div class="two-line-desc" v-if="!isMobile">
          <p class="text-2 bold color-white ma-0">ModularConsultingService</p>
          <p class="text-2 bold color-white ma-0">
            각 분야별 전문가들로 구성되며, 단계별 맞춤 모듈러 컨설팅이
            가능합니다.
          </p>
        </div>
        <div class="icon-process-title" v-if="!isMobile" />
      </div>

      <div class="process-bg" v-if="!isMobile">
        <div class="circle-1" v-scroll-reveal.reset />
        <div class="line-1" v-scroll-reveal.reset />
        <div class="desc-1" v-scroll-reveal.reset>
          <div class="desc-header-1" />
          <div class="text-1 color-white">문제도출과 연구 설계</div>
          <div class="space-25" />
          <div class="text-2 color-white opaque">
            고객사의 연구 목적 파악 및 현황을 진단하고 프로젝트 계획을 수립하는
            단계입니다.
          </div>
          <div class="space-25" />
          <ul class="text-2 color-white opaque">
            <li>요구사항 분석</li>
            <li>연구설계 미팅</li>
            <li>대상 데이터·산출물·방법론 결정</li>
          </ul>
        </div>

        <div class="circle-2" v-scroll-reveal.reset />
        <div class="line-2" v-scroll-reveal.reset />
        <div class="desc-2" v-scroll-reveal.reset>
          <div class="desc-header-2" />
          <div class="text-1 color-white">필요 데이터 구성</div>
          <div class="space-25" />
          <div class="text-2 color-white opaque">
            프로젝트에 필요한 내·외부 데이터를 수집하고 분석의 성능을 높이는
            형태로 가공하는 단계입니다.
          </div>
          <div class="space-25" />
          <ul class="text-2 color-white opaque">
            <li>
              데이터 크롤링 (커뮤니티, 공공데이터, 특허, 기상 등 외부 데이터)
            </li>
            <li>데이터 클리닝</li>
            <li>데이터 전처리</li>
            <li>변수 설계</li>
            <li>대용량 데이터의 분산처리</li>
          </ul>
        </div>

        <div class="circle-3" v-scroll-reveal.reset />
        <div class="line-3" v-scroll-reveal.reset />
        <div class="desc-3" v-scroll-reveal.reset>
          <div class="desc-header-3" />
          <div class="text-1 color-white">데이터 분석과 평가</div>
          <div class="space-25" />
          <div class="text-2 color-white opaque">
            데이터 특성과 프로젝트의 목적을 고려하여 적합한 방법론으로 모델링
            하는 단계입니다. 다수의 모델을 정량적으로 평가 후 가장 성능이 좋은
            모델을 선택 합니다.
          </div>

          <div class="space-25" />
          <ul class="text-2 color-white opaque">
            <li>자연어 처리(NLP)</li>
            <li>IoT·센서 데이터 스트림 마이닝</li>
            <li>딥러닝 기반 알고리즘(AI)</li>
            <li>Network Analysis</li>
            <li>Machine Learning</li>
            <li>Cross Validation</li>
            <li>Agent-based Modelling</li>
          </ul>
        </div>

        <div class="circle-4" v-scroll-reveal.reset />
        <div class="line-4" v-scroll-reveal.reset />
        <div class="desc-4" v-scroll-reveal.reset>
          <div class="desc-header-4" />
          <div class="text-1 color-white">시각화와 커뮤니케이션</div>
          <div class="space-25" />
          <div class="text-2 color-white opaque">
            결과를 해석해서 사람이 이해 할 수 있는 언어로 표현하고, 이해를
            돕거나 모니터링을 쉽 게 해주는 시가화를 제작하는 단계입니다.
          </div>
          <div class="space-25" />
          <ul class="text-2 color-white opaque">
            <li>인포그래픽·PDF 보고서</li>
            <li>인터랙티브 시각화</li>
            <li>대시보드</li>
          </ul>
        </div>
      </div>

      <div class="process-bg-mobile" v-else>
        <div class="desc-wrapper">
          <div class="mg-50" />
          <div class="desc-header-1" />
          <div class="text-2 color-white">문제도출과 연구 설계</div>
          <div class="space-15" />
          <div class="text-3 color-white opaque">
            고객사의 연구 목적 파악 및 현황을 진단하고 프로젝트 계획을 수립하는
            단계입니다.
          </div>
          <div class="mg-50" />
          <div class="desc-header-2" />
          <div class="text-2 color-white">문제도출과 연구 설계</div>
          <div class="space-15" />
          <div class="text-3 color-white opaque">
            프로젝트에 필요한 내·외부 데이터를 수집하고 분석의 성능을 높이는
            형태로 가공하는 단계입니다.
          </div>
          <div class="mg-50" />
          <div class="desc-header-3" />
          <div class="text-2 color-white">데이터 분석과 평가</div>
          <div class="space-15" />
          <div class="text-3 color-white opaque">
            데이터 특성과 프로젝트의 목적을 고려하여 적합한 방법론으로 모델링
            하는 단계입니다. 다수의 모델을 정량적으로 평가 후 가장 성능이 좋은
            모델을 선택 합니다.
          </div>
          <div class="mg-50" />
          <div class="desc-header-4" />
          <div class="text-2 color-white">문제도출과 연구 설계</div>
          <div class="space-15" />
          <div class="text-3 color-white opaque">
            프로젝트에 필요한 내·외부 데이터를 수집하고 분석의 성능을 높이는
            형태로 가공하는 단계입니다.
          </div>
        </div>
        <div class="circle-1" />
        <div class="circle-2" />
        <div class="circle-3" />
        <div class="circle-4" />
      </div>
      <div class="mg-50" v-if="isMobile" />
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
};
</script>

<style>
.process-wrap {
  width: 100%;
  height: 1600px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  position: relative;
  background: rgb(0, 5, 96);
  background: linear-gradient(
    0deg,
    rgba(4, 26, 63, 1) 0%,
    rgba(15, 22, 40, 1) 50%,
    rgba(23, 21, 26, 1) 100%
  );
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.process-bg {
  margin: 0 auto;
  width: 663px;
  height: 1139px;
  position: relative;
  left: -15px;
  background: url("../assets/processmap.png");
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
}

.process-bg-mobile {
  margin-right: auto;
  width: 160px;
  height: 668px;
  position: relative;
  background: url("../assets/ms_processmap.png");
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
}

.section {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 150px;
  top: 0;
  display: block;
}

.title-wrap {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
}

.two-line-desc {
  margin-left: auto;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.icon-process-title {
  width: 32px;
  height: 71px;
  margin-left: 50px;
  background: url("../assets/processsymbol.png") no-repeat center;
  background-size: contain;
}

.circle-1 {
  position: absolute;
  top: 120px;
  right: 160px;
  height: 148px;
  width: 148px;
  background: url("../assets/circle.png") no-repeat center;
  background-size: contain;
  z-index: -1;
}

.circle-2 {
  position: absolute;
  top: 500px;
  left: 0px;
  height: 148px;
  width: 148px;
  background: url("../assets/circle.png") no-repeat center;
  background-size: contain;
  z-index: -1;
}

.circle-3 {
  position: absolute;
  top: 438px;
  left: 268px;
  height: 148px;
  width: 148px;
  background: url("../assets/circle.png") no-repeat center;
  background-size: contain;
  z-index: -1;
}

.circle-4 {
  position: absolute;
  bottom: 75px;
  left: 100px;
  height: 148px;
  width: 148px;
  background: url("../assets/circle.png") no-repeat center;
  background-size: contain;
  z-index: -1;
}

.line-1 {
  position: absolute;
  width: 490px;
  height: 24px;
  top: 90px;
  left: 400px;
  background: url("../assets/numb_line01.png") no-repeat center;
  background-size: contain;
}

.line-2 {
  position: absolute;
  width: 308px;
  height: 24px;
  top: 280px;
  left: -200px;
  background: url("../assets/numb_line02.png") no-repeat center;
  background-size: contain;
}

.line-3 {
  position: absolute;
  width: 287px;
  height: 24px;
  top: 510px;
  right: -227px;
  background: url("../assets/numb_line03.png") no-repeat center;
  background-size: contain;
}

.line-4 {
  position: absolute;
  width: 384px;
  height: 24px;
  bottom: 160px;
  left: -200px;
  background: url("../assets/numb_line04.png") no-repeat center;
  background-size: contain;
  z-index: 1030;
}

.desc-1 {
  position: absolute;
  width: 210px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  top: 65px;
  left: 690px;
  word-break: keep-all;
}

.desc-2 {
  position: absolute;
  width: 210px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  top: 255px;
  left: -190px;
  word-break: keep-all;
}

.desc-3 {
  position: absolute;
  width: 210px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  top: 485px;
  right: -235px;
  word-break: keep-all;
}

.desc-4 {
  position: absolute;
  width: 210px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  bottom: -90px;
  left: -185px;
  word-break: keep-all;
}

.desc-header-1 {
  width: 40px;
  height: 18px;
  background: url("../assets/numb_sym01.png") no-repeat center;
  background-size: contain;
}

.desc-header-2 {
  width: 40px;
  height: 18px;
  background: url("../assets/numb_sym02.png") no-repeat center;
  background-size: contain;
}

.desc-header-3 {
  width: 40px;
  height: 18px;
  background: url("../assets/numb_sym03.png") no-repeat center;
  background-size: contain;
}

.desc-header-4 {
  width: 40px;
  height: 18px;
  background: url("../assets/numb_sym04.png") no-repeat center;
  background-size: contain;
}

@media only screen and (max-width: 880px) {
  .process-wrap {
    height: 100%;
  }

  .desc-wrapper {
    width: 150px;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 170px;
  }

  [class*="desc-header-"] {
    width: 30px;
    height: 12px;
  }

  .space-15 {
    margin-bottom: 5px;
  }

  .circle-1 {
    width: 74px;
    height: 74px;
    top: 65px;
    left: 53px;
  }

  .circle-2 {
    width: 74px;
    height: 74px;
    top: 270px;
    left: 63px;
  }

  .circle-3 {
    width: 74px;
    height: 74px;
    top: 416px;
    left: 23px;
  }

  .circle-4 {
    width: 74px;
    height: 74px;
    top: 545px;
    left: 5px;
  }
}
</style>
